module.exports = __webpack_public_path__ + "img/avatar-default.7df7cfcd.svg";